function Teste() {

  return (
    <h1>Teste</h1>
  );

}

export default Teste;
